
import 'zone.js/dist/zone-error';
export const environment = {
  production: false,
  version: '2024.0.1',
  buildTime: '2024-10-09T10:42:24.697Z',
  environmentName:"QA",
  legacyAwardingCutoffDate: '2026-06-01T00:00:00Z',
  /** Weekday hours after instantPurchaseCreated that Accept stays available. Pauses Fri 8pm ET–Mon 9am ET. */
  instantPurchaseAcceptWindowHours: 36,
  APIEndPoint: 'https://qaappapi.mfg.com/api/',
  HubEndPoint: 'https://qaappapi.mfg.com/',
  AppUrl: 'https://qaapp.mfg.com/',
  SSOUrl: 'https://qa.mfg.com/sso/index.php',
  RedirectionToCommunityPages: 'https://qa.mfg.com/',
  RegistrationLink: 'https://qa.mfg.com/registration/',
  RedirectToMaterialPage: 'http://stagingmaterials.mfg.com/',
  stripePk: 'pk_test_51LONVIGWEpBLxDePtxLdQhseTkUDCUraiqwfqwv0CIYDyh0B4HwWXsKmISdEGMpnsVkdVdxiGcJbgRNI6aPBgw8d002YY8F0AD',
  RedirectToCommunityQuote: 'https://qa.mfg.com/materials-quote-request/',
  ScheduleDemoUrl: 'https://go.mfg.com/meetings/mfgteam/demo',
  ScheduleDemoBuyerUrl: 'https://go.mfg.com/meetings/mfgteam/buyer-demo',
  InteractiveDemoUrl:'https://app.teamwalnut.com/player/?demoId=259c667c-9601-49fa-a77e-c405641637e8&screenId=ff3f4e7a-448a-42da-a0c3-f9e47c6d128e&showGuide=true&showGuidesToolbar=true&showHotspots=true&source=app',
  GettingStartedGuideURL:'https://7872785.fs1.hubspotusercontent-na1.net/hubfs/7872785/Getting%20Started%20With%20MFG%202024.pdf',
  MaterialQuoteRequestFormId:'b4f20342-e6b7-4038-84a0-0f980f164d11',
  MaterialQuoteRequestPortalIdId:'20881509',
  hubSpotFormTrackingGuid: '8faf5b5e-88e6-4759-8d9e-fe7bb229a25e',
  QuoteAssistUiHome:'https://quote.qa.mfg.com/',
  QuoteAssistAPIEndPoint:'https://quotenetapi.qa.mfg.com/api/',
  Sentry: {
      DSN: 'https://df15c8ac92dc2fa40ba1456f93d1992a@o4507262598316032.ingest.us.sentry.io/4507466806657024',
      ReplaysSessionSampleRate: 0,
      ReplaysOnErrorSampleRate:0,
       showDialog:false
    },
  websiteLauncherUrl: 'https://builder.qa.mfg.com/form-builder-v2',
  editRequestUrl: 'https://request-dev.ottodms.io/edit-request.php',
  noQuoteFeedbackApiKey: 'MFG_NoQuote_QA_SecretKey_2024_qA5bN8jR2wK6xM4yF9tC',
  userPersonalizationApiUrl: 'https://user-personalization.qa.mfg.com',
  widgetUrl: 'https://d269gqsitvvmy9.cloudfront.net/widget/rfq-intake.js',
  supplierNetworkIframeUrl: 'https://d269gqsitvvmy9.cloudfront.net/widget/supplier-network.js',
};
